export const PARENT_SESSION_TIMEOUT_MS = 5 * 60 * 1000;
export const PARENT_GATE_COOLDOWN_MS = 30 * 1000;
export const MAX_PARENT_PIN_ATTEMPTS = 5;

export function isValidParentPin(pin: string): boolean {
  return /^\d{4}$/.test(pin);
}

export function verifyParentPin(input: string, configuredPin: string): boolean {
  return isValidParentPin(input) && isValidParentPin(configuredPin) && input === configuredPin;
}

export function isParentSessionExpired(unlockedAt: number, now = Date.now()): boolean {
  return now - unlockedAt >= PARENT_SESSION_TIMEOUT_MS;
}

export function isParentGateCoolingDown(cooldownUntil: number, now = Date.now()): boolean {
  return cooldownUntil > now;
}
